var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#FFF1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#BC4841"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 11.2H17.6C17.6 10.7757 17.4314 10.3687 17.1314 10.0686C16.8313 9.76857 16.4243 9.6 16 9.6C15.5757 9.6 15.1687 9.76857 14.8686 10.0686C14.5686 10.3687 14.4 10.7757 14.4 11.2ZM12.8 11.2C12.8 10.3513 13.1371 9.53737 13.7373 8.93726C14.3374 8.33714 15.1513 8 16 8C16.8487 8 17.6626 8.33714 18.2627 8.93726C18.8629 9.53737 19.2 10.3513 19.2 11.2H23.2C23.4122 11.2 23.6157 11.2843 23.7657 11.4343C23.9157 11.5843 24 11.7878 24 12C24 12.2122 23.9157 12.4157 23.7657 12.5657C23.6157 12.7157 23.4122 12.8 23.2 12.8H22.4944L21.7856 21.072C21.7175 21.8708 21.352 22.6149 20.7615 23.1571C20.171 23.6993 19.3985 24.0001 18.5968 24H13.4032C12.6015 24.0001 11.829 23.6993 11.2385 23.1571C10.648 22.6149 10.2825 21.8708 10.2144 21.072L9.5056 12.8H8.8C8.58783 12.8 8.38434 12.7157 8.23431 12.5657C8.08429 12.4157 8 12.2122 8 12C8 11.7878 8.08429 11.5843 8.23431 11.4343C8.38434 11.2843 8.58783 11.2 8.8 11.2H12.8ZM18.4 16C18.4 15.7878 18.3157 15.5843 18.1657 15.4343C18.0157 15.2843 17.8122 15.2 17.6 15.2C17.3878 15.2 17.1843 15.2843 17.0343 15.4343C16.8843 15.5843 16.8 15.7878 16.8 16V19.2C16.8 19.4122 16.8843 19.6157 17.0343 19.7657C17.1843 19.9157 17.3878 20 17.6 20C17.8122 20 18.0157 19.9157 18.1657 19.7657C18.3157 19.6157 18.4 19.4122 18.4 19.2V16ZM14.4 15.2C14.6122 15.2 14.8157 15.2843 14.9657 15.4343C15.1157 15.5843 15.2 15.7878 15.2 16V19.2C15.2 19.4122 15.1157 19.6157 14.9657 19.7657C14.8157 19.9157 14.6122 20 14.4 20C14.1878 20 13.9843 19.9157 13.8343 19.7657C13.6843 19.6157 13.6 19.4122 13.6 19.2V16C13.6 15.7878 13.6843 15.5843 13.8343 15.4343C13.9843 15.2843 14.1878 15.2 14.4 15.2ZM11.808 20.936C11.8421 21.3355 12.0249 21.7077 12.3204 21.9788C12.6158 22.2499 13.0022 22.4002 13.4032 22.4H18.5968C18.9975 22.3998 19.3836 22.2494 19.6786 21.9783C19.9737 21.7072 20.1563 21.3352 20.1904 20.936L20.888 12.8H11.112L11.808 20.936Z",
    fill: "#BC4841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b7992b6654f18b6ed5eb9226d60a44f5.svg";
export { ForwardRef as ReactComponent };